import { render, staticRenderFns } from "./CollectionsLineChart.vue?vue&type=template&id=1177c6d6&"
import script from "./CollectionsLineChart.vue?vue&type=script&lang=js&"
export * from "./CollectionsLineChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports